export default function runInBackground(
  promise: Promise<unknown>,
  onError?: (e: unknown) => void,
) {
  promise.catch(onError ?? (() => {}));
}
